import {Trans} from '@lingui/macro';
import {range} from 'lodash';
import React, {FC} from 'react';

import {HandlerOf} from '../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {collectEnumValues} from '../../../../../../libs/shared/helpers/src/typescript/enumHelpers';
import {SimpleDropdown} from '../../../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown';
import {SimpleDropdownItem} from '../../../../../../libs/shared/ui/src/components/dropdowns/simpleDropdownItem';
import {RepositionPopoverProps} from '../../../../../../libs/shared/ui/src/components/popovers/repositionPopover';
import {DropdownCategory} from '../../../../../components/common/dropdowns/dropdownCategory';
import {
  MAX_REGEX_PART_REPEAT,
  RegexCharacterClassesEnum,
  RegexPart,
} from '../../../../editors/commons/stringTemplateModel';
import {RegexPartDropdownItem} from './regexPartDropdownItem';

export interface RegexPartSettingsPopoverProps extends RepositionPopoverProps {
  part: RegexPart;
  onPartUpdate: HandlerOf<RegexPart>;
}

export const RegexPartSettingsPopover: FC<RegexPartSettingsPopoverProps> = (props) => {
  const {anchor, onRequestClose} = props;

  return (
    <SimpleDropdown anchor={anchor} isExclusive width={300} onRequestClose={onRequestClose}>
      <DropdownCategory>Character classes</DropdownCategory>
      {renderClasses(props)}
      <DropdownCategory>Repeat</DropdownCategory>
      {renderRepeats(props)}
    </SimpleDropdown>
  );
};

function renderClasses(props: RegexPartSettingsPopoverProps) {
  const {part, onPartUpdate} = props;

  return collectEnumValues(RegexCharacterClassesEnum).map((charClass) => (
    <RegexPartDropdownItem
      key={`class-${charClass}`}
      onSelect={() => onPartUpdate({char: charClass, repeat: part.repeat})}
      isChecked={charClass === part.char}
      part={{char: charClass}}
    />
  ));
}

function renderRepeats(props: RegexPartSettingsPopoverProps) {
  const {part, onPartUpdate} = props;

  return (
    <>
      <SimpleDropdownItem
        key="repeat-any"
        onSelect={() => onPartUpdate({char: part.char})}
        isChecked={!part.repeat}
      >
        <Trans id="regex-settings-oneormore">One or more</Trans>
      </SimpleDropdownItem>

      {range(1, MAX_REGEX_PART_REPEAT + 1).map((repeat) => (
        <SimpleDropdownItem
          key={`repeat-${repeat}`}
          onSelect={() => onPartUpdate({char: part.char, repeat})}
          isChecked={repeat === part.repeat}
        >
          <Trans id="regex-settings-exactly">Exactly {repeat}</Trans>
        </SimpleDropdownItem>
      ))}
    </>
  );
}
